import PartsRecyclingHomeUnity from './home';
import RecycleRecord from './components/recycleRecord' //回收记录
import ScratchCardGift from './components/scratchCardGift' //刮奖拿豪礼
import RecycleEpicApeOrBet from './components/recycleEpicApeOrBet' //回收得史诗款/押注
export default {
    PartsRecyclingHomeUnity,
    RecycleRecord,
    ScratchCardGift,
}
